import dict from '../data/dictionary.json';

import Shepherd from 'shepherd.js';
import { offset } from '@floating-ui/dom';

import { Sesion, Solr } from '../main.js';
import { getLiteral } from './util.js';
import { sendEvent } from './events.js';

function lanzarTour() {
	// marco como completado el tour para que no recargue todo el rato el tour
	localStorage.setItem('tourCompletado', true); // cuidado, que setItem sólo guarda strings

	// empieza tutorial
	sendEvent( 'tutorial_begin' );

	// creo tour
	const tour = new Shepherd.Tour({
		useModalOverlay: true,
		defaultStepOptions: {
			cancelIcon: { enabled: true },
			//classes: 'class-1 class-2',
		    scrollTo: { behavior: 'smooth', block: 'center' }
		}
	});

	// creo los pasos del tour
	//'Welcome',
	tour.addStep({
		title: getLiteral(dict.tourTitle0),
		text: getLiteral(dict.tourText0),
		buttons: [
			{
				text: getLiteral(dict.tourExit),
				classes: 'shepherd-button-secondary',
				action() {
					return this.complete();
				}
			}, 
			{
				text: getLiteral(dict.tourNext),
				action: tour.next
			}
		]
	});
	// "The map",
	tour.addStep({
		title: getLiteral(dict.tourTitle2),
		text: getLiteral(dict.tourText2),
		classes: 'mt-3',
		attachTo: {
			element: '#mimapa',
		    on: 'bottom'
		},
		//floatingUIOptions: { middleware: [offset({ mainAxis: 15, crossAxis: 0 })] },
		buttons: [
			{
				text: getLiteral(dict.tourBack),
				classes: 'shepherd-button-secondary',
				action() {
					return this.back();
				}
			}, 
			{
				text: getLiteral(dict.tourNext),
				action: tour.next
			}
		]
	});
	//'Zoom',
	if (!L.Browser.mobile) {
		tour.addStep({
			title: getLiteral(dict.tourTitle3),
			text: getLiteral(dict.tourText3),
			classes: 'mt-3',
			attachTo: {
				element: '.leaflet-control-zoom',
				on: 'bottom'
			},
			//floatingUIOptions: { middleware: [offset({ mainAxis: 15, crossAxis: 0 })] },
			buttons: [
				{
					text: getLiteral(dict.tourBack),
					classes: 'shepherd-button-secondary',
					action() {
						return this.back();
					}
				}, 
				{
					text: getLiteral(dict.tourNext),
					action() {
						return this.next();
					}
				}
			]
		});
	}
	if (Solr) {
		//'Search places',	
		tour.addStep({
			title: getLiteral(dict.tourTitle4),
			text: getLiteral(dict.tourText4),
			classes: 'mt-3',
			attachTo: {
				element: '.buscar_lugares',
				on: 'bottom'
			},
			buttons: [
				{
					text: getLiteral(dict.tourBack),
					classes: 'shepherd-button-secondary',
					action() {
						return this.back();
					}
				}, 
				{
					text: getLiteral(dict.tourNext),
					action() {
						return this.next();
					}
				}
			]
		});
	}
	//'mapa base',
	tour.addStep({
		title: getLiteral(dict.tourTitle5),
		text: getLiteral(dict.tourText5),
		classes: 'mt-3',
		attachTo: {
			element: '.div-layers',
		    on: 'bottom'
		},
		buttons: [
			{
				text: getLiteral(dict.tourBack),
				classes: 'shepherd-button-secondary',
				action() {
					return this.back();
				}
			}, 
			{
				text: getLiteral(dict.tourNext),
				action() {
					return this.next();
				}
			}
		]
	});
	//'Edición del IFN',
	tour.addStep({
		title: getLiteral(dict.tourTitle6),
		text: getLiteral(dict.tourText6),
		classes: 'mt-3',
		attachTo: {
			element: '.ifnradio',
		    on: 'bottom'
		},
		buttons: [
			{
				text: getLiteral(dict.tourBack),
				classes: 'shepherd-button-secondary',
				action() {
					return this.back();
				}
			}, 
			{
				text: getLiteral(dict.tourNext),
				action() {
					return this.next();
				}
			}
		]
	});
	//'Draw a polygon',
	tour.addStep({
		title: getLiteral(dict.tourTitle7),
		text: getLiteral(dict.tourText7),
		classes: 'mt-3',
		attachTo: {
			element: '.collpoli',
		    on: 'bottom'
		},
		//floatingUIOptions: { middleware: [offset({ mainAxis: 15, crossAxis: 0 })] },
		buttons: [
			{
				text: getLiteral(dict.tourBack),
				classes: 'shepherd-button-secondary',
				action() {
					return this.back();
				}
			}, 
			{
				text: getLiteral(dict.tourNext),
				action() {
					return this.next();
				}
			}
		]
	});
	//'Filter taxon',	
	tour.addStep({
		title: getLiteral(dict.tourTitle8),
		text: getLiteral(dict.tourText8),
		//classes: 'mb-5',
		attachTo: {
			element: '#bot_taxones',
		    on: 'top'
		},
		floatingUIOptions: { middleware: [offset({ mainAxis: 15, crossAxis: 0 })] },
		buttons: [
			{
				text: getLiteral(dict.tourBack),
				classes: 'shepherd-button-secondary',
				action() {
					return this.back();
				}
			}, 
			{
				text: getLiteral(dict.tourNext),
				action() {
					return this.next();
				}
			}
		]
	});
	//'Scientific names',
	tour.addStep({
		title: getLiteral(dict.tourTitle9),
		text: getLiteral(dict.tourText9),
		//classes: 'mb-5',
		attachTo: {
			element: '#labchecknomci',
		    on: 'top'
		},
		floatingUIOptions: { middleware: [offset({ mainAxis: 15, crossAxis: 0 })] },
		buttons: [
			{
				text: getLiteral(dict.tourBack),
				classes: 'shepherd-button-secondary',
				action() {
					return this.back();
				}
			}, 
			{
				text: getLiteral(dict.tourNext),
				action() {
					return this.next();
				}
			}
		]
	});
	// "Configure a plot filter",
	const targetplot = document.querySelector('.tune_filter_taxon')? '.tune_filter_taxon' : '#filter-plantae';	
	//document.getElementById('filter-plantae')? '#filter-plantae' : '.tune_filter_taxon';
	tour.addStep({
		title: getLiteral(dict.tourTitle9a),
		text: getLiteral(dict.tourText9a),
		attachTo: {
			element: targetplot,
		    on: 'top'
		},
		floatingUIOptions: { middleware: [offset({ mainAxis: 15, crossAxis: 0 })] },
		buttons: [
			{
				text: getLiteral(dict.tourBack),
				classes: 'shepherd-button-secondary',
				action() {
					return this.back();
				}
			}, 
			{
				text: getLiteral(dict.tourNext),
				action: tour.next
			}
		]
	});
	// "Taxon information"
	const targettx = document.querySelectorAll('.info_taxon').length > 1? document.querySelectorAll('.info_taxon')[1] : '.info_taxon';
	tour.addStep({
		title: getLiteral(dict.tourTitle9b),
		text: getLiteral(dict.tourText9b),
		attachTo: {
			element: targettx,
		    on: 'top'
		},
		floatingUIOptions: { middleware: [offset({ mainAxis: 15, crossAxis: 0 })] },
		buttons: [
			{
				text: getLiteral(dict.tourBack),
				classes: 'shepherd-button-secondary',
				action() {
					return this.back();
				}
			}, 
			{
				text: getLiteral(dict.tourNext),
				action: tour.next
			}
		]
	});	
	// "taxon color"
	if (document.querySelector('.color_filtro')) {
		tour.addStep({
			title: getLiteral(dict.tourTitle9c),
			text: getLiteral(dict.tourText9c),
			attachTo: {
				element: '.color_filtro',
				on: 'top'
			},
			floatingUIOptions: { middleware: [offset({ mainAxis: 15, crossAxis: 0 })] },
			buttons: [
				{
					text: getLiteral(dict.tourBack),
					classes: 'shepherd-button-secondary',
					action() {
						return this.back();
					}
				}, 
				{
					text: getLiteral(dict.tourNext),
					action: tour.next
				}
			]
		});
	}
	// "remove taxon"
	if (document.querySelector('.quitar_taxon')) {
		tour.addStep({
			title: getLiteral(dict.tourTitle9d),
			text: getLiteral(dict.tourText9d),
			attachTo: {
				element: '.quitar_taxon',
				on: 'top'
			},
			floatingUIOptions: { middleware: [offset({ mainAxis: 15, crossAxis: 0 })] },
			buttons: [
				{
					text: getLiteral(dict.tourBack),
					classes: 'shepherd-button-secondary',
					action() {
						return this.back();
					}
				}, 
				{
					text: getLiteral(dict.tourNext),
					action: tour.next
				}
			]
		});
	}	
	// "map features",
	tour.addStep({
		title: getLiteral(dict.tourTitle10),
		text: getLiteral(dict.tourText10),
		classes: 'mt-3',
		attachTo: {
			element: '#mimapa',
		    on: 'bottom'
		},
		//floatingUIOptions: { middleware: [offset({ mainAxis: 15, crossAxis: 0 })] },
		buttons: [
			{
				text: getLiteral(dict.tourBack),
				classes: 'shepherd-button-secondary',
				action() {
					return this.back();
				}
			}, 
			{
				text: getLiteral(dict.tourNext),
				action: tour.next
			}
		]
	});
	//'# of selected plots',
	tour.addStep({
		title: getLiteral(dict.tourTitle11),
		text: getLiteral(dict.tourText11),
		//classes: 'mb-3',
		attachTo: {
			element: '#numplots',
		    on: 'top'
		},
		floatingUIOptions: { middleware: [offset({ mainAxis: 15, crossAxis: 0 })] },
		buttons: [
			{
				text: getLiteral(dict.tourBack),
				classes: 'shepherd-button-secondary',
				action() {
					return this.back();
				}
			}, 
			{
				text: getLiteral(dict.tourNext),
				action() {
					return this.next();
				}
			}
		]
	});
	//'download',
	tour.addStep({
		title: getLiteral(dict.tourTitle12),
		text: getLiteral(dict.tourText12),
		//classes: 'mt-3',
		attachTo: {
			element: '#botdescargar',
		    on: 'top'
		},
		floatingUIOptions: { middleware: [offset({ mainAxis: 15, crossAxis: 0 })] },
		buttons: [
			{
				text: getLiteral(dict.tourBack),
				classes: 'shepherd-button-secondary',
				action() {
					return this.back();
				}
			}, 
			{
				text: getLiteral(dict.tourNext),
				action() {
					return this.next();
				}
			}
		]
	});
	//'More options',
	tour.addStep({
		title: getLiteral(dict.tourTitle13),
		text: getLiteral(dict.tourText13),
		classes: 'mt-3',
		attachTo: {
			element: '#bot_inicio',
		    on: 'bottom'
		},
		buttons: [
			{
				text: getLiteral(dict.tourBack),
				classes: 'shepherd-button-secondary',
				action() {
					return this.back();
				}
			}, 
			{
				text: getLiteral(dict.tourNext),
				action() {
					return this.next();
				}
			}
		]
	});
	//'tour',
	tour.addStep({
		title: getLiteral(dict.tourTitle14),
		text: getLiteral(dict.tourText14),
		classes: 'mt-3',
		attachTo: {
			element: '.tour',
		    on: 'bottom'
		},
		//floatingUIOptions: { middleware: [offset({ mainAxis: 15, crossAxis: 0 })] },
		buttons: [
			{
				text: getLiteral(dict.tourBack),
				classes: 'shepherd-button-secondary',
				action() {
					return this.back();
				}
			}, 
			{
				text: getLiteral(dict.tourNext),
				action() {
					return this.next();
				}
			}
		]
	});
	//'The end',
	tour.addStep({
		title: getLiteral(dict.tourTitle15),
		text: getLiteral(dict.tourText15),
		buttons: [
			{
				text: getLiteral(dict.tourBack),
				classes: 'shepherd-button-secondary',
				action() {
					return this.back();
				}
			}, 
			{
				text: getLiteral(dict.tourDone),
				action() {
					// fin tutorial
					sendEvent( 'tutorial_complete' );
					return this.complete();
				}
			}
		]
	});	
	
	// lanzo...
	tour.start();
}

export { lanzarTour };